

let language = {
    CARD_COUPON_CODE: "Coupon Code:",
    CARD_REDEEM: "Redeem",
    CARD_ONLY: "Only",
    CARD_COUPON_ALLOWED_PER_ORDER: "coupon is allowed per order",
    CARD_COUPON_CODE_APPLIED:"coupon has been successfully applied."
}

export { language }
